module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAABZ0lEQVQ4jY3Tu0scURjG4WfXIVEUIRCiLIIgYpOAJClTBFz/AUu7gLiNYhcI2ArpAmmsbC3SpUibGzaCF7SwES0koCiSgIkYibdiviHDZNzN28y5fb/zvufMqTQaDaF7qGMYl1qrij9YxackBrvwMiY+oKMJ4DrWTeIFDjCfoA0D2Av62n+46cm1ezGSOarELvfxKuA7WIx2pq+Yxi9sYSq+J0luUYIjvImo3/HuFkePY36zVqutZcWZLsPRODoj+0w4ugrXe3iN0yI5D6qG5Y/R/4kfASA95ENs41Ez0HXs/kx6a7uYRXvMwQre4rwZqBLxdnAXx9LDvZMD7QekqwiqljgaxMNwlRTWn+B3oa6lozNchKNM3RH1qhXoHOu5sbliQahWBprAE/ThKb75N1JVGn0JX5S8xQRjGC0pLtM8NqSR+XsJErzHkPS9tVJdGr0nXG3nQQtYxnM8yO12m/oD9ln6A4MbB19TsLnd4k8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/content/images/icon-order.png
// module id = HOZA
// module chunks = 11